/**
 * @file
 * A JavaScript file for Location detail pages.
 *
 * @copyright Copyright 2020 Palantir.net
 *
 */

// eslint-disable-next-line func-names
(function ($) {
  // Append alert and CTA blocks on Location nodes on top of the page for mobile.
  Drupal.behaviors.locationCta = {
    attach() {
      if ($("body").hasClass("page-node-location")) {
        let windowsize = $(window).width();
        if (windowsize < 1040) {
          $(".card--appointments-rail").prependTo(".l-main");
          $("#page-alert-right-rail-wysiwyg").prependTo(".l-main");
        }

        $(window).resize(() => {
          windowsize = $(window).width();
          if (windowsize < 1040) {
            $(".card--appointments-rail").prependTo(".l-main");
            $("#page-alert-right-rail-wysiwyg").prependTo(".l-main");
          } else {
            $(".card--appointments-rail").prependTo(".l-sidebar");
            $("#page-alert-right-rail-wysiwyg").prependTo(".l-sidebar");
          }
        });
      }
    }
  };

  Drupal.behaviors.initSlider = {
    // eslint-disable-next-line no-unused-vars
    attach(_context, settings) {
      $(document).ready(() => {
        // Slick slider for multiple location images.
        $(".location-header__slider").slick({
          slidesToShow: 1,
          // phpcs:disable
          adaptiveHeight: false,
          slidesToScroll: 1,
          autoplay: false,
          // autoplaySpeed: 8000,
          // infinite: true,
          arrows: false,
          dots: true
          // phpcs:enable
        });
      });
    }
  };
})(jQuery);
